// extracted by mini-css-extract-plugin
module.exports = {"step":"WizardStep_step__31nlq","number":"WizardStep_number__w0LVJ","text":"WizardStep_text__36ZQW","active":"WizardStep_active__28OgF","visited":"WizardStep_visited__3Z-u6"};